import { Singleton } from '@visiba/instantiation';

@Singleton()
export class IdpUrlRedirectStorageService {
	public idpUrlRedirectStorage: Nullable<string> = null;

	public setRedirectPath(url: string) {
		this.idpUrlRedirectStorage = url;
	}
}
